(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/syndicate/core/assets/javascripts/handlebars-helpers.js') >= 0) return;  svs.modules.push('/components/syndicate/core/assets/javascripts/handlebars-helpers.js');

(function(_) {
  'use strict';

  if (svs.isServer) {
    registerHelpers(require('hbs'));
  } else {
    registerHelpers(Handlebars);
  }

  function registerHelpers(hbs) {
    hbs.registerHelper('displaySyndicateState', function(syndicate, options) {
      var syn = syndicate || {};

      var playableAmount = syn.playableAmount;
      var tooFewMembers = syn.tooFewMembers;
      var memberState;
      var state = '';
      var iconClass = 'icon-exclamation-sign';
      var args = [];

      if (_.isString(syn.memberState)) {
        memberState = syn.memberState;
      } else if (syn.currentMember) {
        memberState = syn.currentMember.get('memberState');
      }

      var intAmount = typeof playableAmount === 'number' ? playableAmount : parseInt(playableAmount, 10);

      if (memberState === 'INACTIVE') {
        state = 'Du är vilande i laget.';
        iconClass = 'icon-exclamation-sign';
      } else if (tooFewMembers) {
        if (svs.core.detect.formfactor.desktop()) {
        } else {
          state = 'Laget har för få medlemmar.';
          iconClass = 'icon-exclamation-sign';
        }
      } else if (!intAmount) {
        state = 'Inget spelbart saldo.';
        iconClass = 'icon-exclamation-sign';
        return null;
      }

      args.push(state);
      args.push(iconClass);
      args[args.length - 1] = args[args.length - 1].substr(5);

      return options.fn(this, { data: options.data, blockParams: args });
    });

    hbs.registerHelper('syndicateHasDraws', function(syndicate, options) {
      var wagers = syndicate.wagers;

      if (wagers && wagers.length > 0) {
        return options.fn(this);
      }
      return options.inverse(this);
    });

    hbs.registerHelper('syndicateIsActive', function(syndicateState, options) {
      return syndicateState === svs.syndicate.core.data.constants.syndicateState.ACTIVE ? options.fn(this) : options.inverse(this);
    });

    hbs.registerHelper('memberIsActive', function(memberState, options) {
      return memberState === svs.syndicate.core.data.constants.syndicateMemberState.ACTIVE ? options.fn(this) : options.inverse(this);
    });

    hbs.registerHelper('syndicateCanAddMembers', function(syndicateState, options) {
      return syndicateState === svs.syndicate.core.data.constants.syndicateState.ACTIVE ? options.fn(this) : options.inverse(this);
    });

    hbs.registerHelper('syndicateIsPlayable', function(syndicate, options) {
      var intAmount = typeof syndicate.playableAmount === 'number' ? syndicate.playableAmount : parseInt(syndicate.playableAmount, 10);
      var memberState;

      if (_.isString(syndicate.memberState)) {
        memberState = syndicate.memberState;
      } else if (syndicate.currentMember) {
        memberState = syndicate.currentMember.get('memberState');
      }

      return memberState == 'ACTIVE' && intAmount && !syndicate.tooFewMembers ? options.fn(this) : options.inverse(this);
    });

    hbs.registerHelper('getInitials', function(name, lastName) {
      name = name || '';
      lastName = lastName || '';
      lastName = lastName || name.split(' ').pop();
      return name.charAt(0) + lastName.charAt(0);
    });

    hbs.registerHelper('displayMemberRole', function(syndicate, displayUpperCase) {
      var roleNumber;
      var role = '';

      if (!syndicate) {
        return '';
      }

      roleNumber = syndicate instanceof Backbone.Model ? syndicate.get('memberRole') : syndicate.memberRole ? syndicate.memberRole : syndicate;

      switch (roleNumber) {
        case 4: 
          role = '';
          break;
        case 7: 
        case 5:
          role = 'Lagledare';
          break;
        default:
          svs.syndicate.syndicate_overview.logger.error('Unknown member role: ', syndicate);
      }
      return displayUpperCase ? role.toUpperCase() : role;
    });

    hbs.registerHelper('isOwner', function(syndicate, options) {
      if (!syndicate) {
        return options.inverse(this);
      }

      if (syndicate instanceof Backbone.Model) {
        if (syndicate.isOwner()) {
          return options.fn(this);
        }
        return options.inverse(this);
      }

      var roleNumber = syndicate.memberRole ? syndicate.memberRole : syndicate;

      if ((roleNumber & svs.syndicate.core.data.constants.SyndicateMemberPermissions.OWNER) === svs.syndicate.core.data.constants.SyndicateMemberPermissions.OWNER) {
        return options.fn(this);
      }
      return options.inverse(this);
    });

    hbs.registerHelper('getMemberBalance', function(syndicate) {
      if (syndicate.currentMember) {
        return svs.utils.format.Currency(syndicate.currentMember.get('memberBalance'));
      } else if (syndicate.members) {
        var balance = _.findWhere(syndicate.members, { isCurrentMember: true }).memberBalance;
        return svs.utils.format.Currency(balance);
      }
      return '';
    });

    hbs.registerHelper('balanceOverZero', function(syndicate, options) {
      return parseInt(Handlebars.helpers.getMemberBalance(syndicate), 10) > 0 ? options.fn(this) : options.inverse(this);
    });

    hbs.registerHelper('ongoingUrl', function(wager) {
      return svs.core.urlMapping.get(svs.utils.url.encode(wager.productName) + '_OngoingBets') || '#';
    });

    hbs.registerHelper('currentDraw', function(wager) {
      if (wager.productName === 'Keno') {
        return 'Dag ' + wager.completedDrawCount + ' av ' + wager.totalDrawCount;
      }
      return 'v. ' + wager.completedDrawCount + ' av ' + wager.totalDrawCount;
    });

    hbs.registerHelper('gameDate', function(dateString) {
      var date = new Date(dateString);
      var inDate = dateFns.startOfDay(date);
      var today = dateFns.startOfDay(new Date());
      var gameDate = date;
      var includeTime = arguments[1] || false;

      if (inDate.isValid()) {
        var formattedDate;
        switch (inDate.diff(today, 'days')) {
          case -1:
            formattedDate = 'igår';
            break;
          case 0:
            formattedDate = 'idag';
            break;
          case 1:
            formattedDate = 'imorgon';
            break;
          default:
            formattedDate = gameDate.format('D/M');
            break;
        }
        return includeTime ? formattedDate + ', kl. ' + gameDate.format('HH:mm') : formattedDate;
      }

      return '';
    });

    hbs.registerHelper('syndicateTeamDetailUrl', function(syndicateId) {
      return svs.core.data.baseUrl + '/minalag/' + syndicateId;
    });
  }
})(_);


 })(window);